// extracted by mini-css-extract-plugin
export default {"card":"ApplicationTip_card__pn1fn","footer":"ApplicationTip_footer__a5L75","title":"ApplicationTip_title__Z1tLm","closeButton":"ApplicationTip_closeButton__tApgZ"};